import React, { PureComponent } from 'react'
import { TextInput } from 'components/dpc_input'

class TextInputForm extends PureComponent {

	render() {
		/*if(this.props.meta.error || this.props.error || this.props.input.error) {
			console.log('I HAVE RROR:', this.props)
		}*/
		const value = this.props.meta.dirty ? this.props.input.value : this.props.meta.initial || ''
		return (
			<TextInput
				type={this.props.type}
				icons={this.props.icons}
				tooltip={this.props.tooltip}
				status={this.props.fieldStatus(this.props.meta, this.props.input.name, value)}
				placeholder={this.props.placeholder}
				message={this.props.getMessage(this.props.meta, this.props.input.name, value)}
				disabled={this.props.disabled}
				maxLength={this.props.maxLength}
				activeStyle={this.props.activeStyle}
				uppercase={this.props.uppercase}
				autoComplete={this.props.autoComplete}
				boxType={this.props.boxType}
				button={this.props.button}
				color={this.props.color}
				active={this.props.meta.active}
				{...this.props.input}
				onInput = {this.props.onInput ? value => this.props.onInput(this.props.input, value) : this.props.onInput}
			/>
		)
	}
}

TextInputForm.defaultProps = {
	getMessage: () => '',
	fieldStatus: () => '',
}

export default TextInputForm
